export default __webpack_public_path__ + "static/media/discord-button.13f463e3.png";